import React from 'react'
import LoaderTable from '../../hooks/loaderTable';
import { convertFromWeiEthers, formatSmartDecimal, getBackgroundColor } from '../../utils/helpers';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { useTheme } from '../../contexts/ThemeProvider';

const TopHolders = ({ loadertable, poolsdetail, setSelectedIndex, getTopHolders, selectedIndex, topholders, tokenDecimals, isMobile }) => {
    const { t } = useTranslation();
    const { theme } = useTheme();
    return (
        <>
            <div className="top-holders">
                <h6 className="heading-text">{t("Top Holders")}</h6>
                <div className="inline-teams">
                    {loadertable ? (
                        <div className="m-5">
                            <LoaderTable />
                        </div>
                    ) : (
                        poolsdetail?.options?.map((option, index) => {
                            const background = getBackgroundColor(
                                index,
                                theme,
                                poolsdetail?.options?.length
                            );
                            return (
                                <div
                                    onClick={() => {
                                        setSelectedIndex(index);
                                        getTopHolders(option.choiceIndex);
                                    }}
                                    className="single-team"
                                    style={{
                                        borderColor:
                                            selectedIndex === index
                                                ? background
                                                : "var(--border17)",
                                    }}
                                >
                                    <span
                                        style={{ backgroundColor: background }}
                                    ></span>
                                    <p>{option?.optionName}</p>
                                </div>
                            );
                        })
                    )}
                </div>
                {
                    !isMobile ? <>{topholders?.holders?.map((item, index) => {
                        const sharesfromwei = convertFromWeiEthers(
                            String(parseFloat(item?.shares)),
                            tokenDecimals
                        );
                        return (
                            <div key={index} className="holder-items">
                                <div className="single-item">
                                    <div className="inner-left">
                                        <p>{t("Holder")}</p>
                                        <Link className="creator_link" to={`/user-profile?id=${item?.user?._id}`}>

                                            <h6>

                                                <img
                                                    src={
                                                        item?.user?.profilePicture ||
                                                        "/assets/detailpage/placeholder.svg"
                                                    }
                                                    alt="img"
                                                    className="img-fluid"
                                                />
                                                {/* {item.user.username?.slice(0, 5)}...{item.user.username?.slice(-3)} */}
                                                {item.user.username
                                                    ? item.user.username.length > 40
                                                        ? `${item.user.username.slice(
                                                            0,
                                                            5
                                                        )}...${item.user.username.slice(-3)}`
                                                        : item.user.username
                                                    : t("Unknown User")}
                                            </h6>
                                        </Link>

                                    </div>
                                    <div className="inner-right">
                                        <p>{t("Shares")}</p>
                                        <h6>{formatSmartDecimal(sharesfromwei)}</h6>
                                    </div>
                                </div>
                            </div>
                        );
                    })}</> : <>
                        <div className="mobile-holder-items">
                            <div className="upper-field">
                                <p>Holder</p>
                                <p>Shares</p>
                            </div>
                            {topholders?.holders?.map((item, index) => {
                                const sharesfromwei = convertFromWeiEthers(
                                    String(parseFloat(item?.shares)),
                                    tokenDecimals
                                );
                                return (
                                    <div key={index} className="single-item">
                                        <div className="left-holder">
                                            <p>{index + 1}</p>
                                            <h6>
                                                <img
                                                    src={item?.user?.profilePicture || "/assets/detailpage/placeholder.svg"}
                                                    alt="img"
                                                    className='img-fluid'
                                                />
                                                {item.user.username
                                                    ? item.user.username.length > 20
                                                        ? `${item.user.username.slice(0, 5)}...${item.user.username.slice(-3)}`
                                                        : item.user.username
                                                    : t("Unknown User")}
                                            </h6>
                                        </div>
                                        <div className="right-holder">
                                            <h6>{formatSmartDecimal(sharesfromwei)}</h6>
                                        </div>
                                    </div>
                                );
                            })}
                        </div>
                    </>
                }
            </div>
        </>
    )
}

export default TopHolders
